import type { JSX } from 'react';
import { Button, FormParagraph } from '@ksyos/design-system';
import { ProcessStatus } from '@common/enums';
import { Modal } from '@frontend/components/elements/modals/Modal';
import { getSelectedLanguage } from '@frontend/translate';

type UpdateProcessDetailsModalProps = Readonly<{
    currentProcessStatus: ProcessStatus;
    onClose: () => void;
    onConfirm: () => Promise<void>;
}>;

export function UpdateProcessDetailsModal({
    currentProcessStatus,
    onClose,
    onConfirm,
}: UpdateProcessDetailsModalProps): JSX.Element {
    const updateWarning = getSelectedLanguage().processDetails.updateWarning;
    const updateActiveToCanceled = getSelectedLanguage().processDetails.updateActiveToCanceled;
    const updateConfirm = getSelectedLanguage().processDetails.updateConfirm;
    const modalText = `${updateWarning}\n\n${currentProcessStatus === ProcessStatus.active ? updateActiveToCanceled + '\n\n' : ''}${updateConfirm}`;

    return (
        <Modal
            actionButtons={[
                <Button
                    key="no"
                    onClick={onClose}
                    variant="outline"
                >
                    {getSelectedLanguage().common.no}
                </Button>,
                <Button
                    key="yes"
                    onClick={onConfirm}
                >
                    {getSelectedLanguage().common.yes}
                </Button>,
            ]}
            closeOnEsc={true}
            closeOnOverlayClick={true}
            isOpen={true}
            onClose={onClose}
            size="medium"
            title={getSelectedLanguage().common.areYouSure}
        >
            <FormParagraph>{modalText}</FormParagraph>
        </Modal>
    );
}
